// @flow
import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  DateTime,
  Interval,
} from 'luxon';
import {
  actionTypes,
} from 'redux-resource';

import type {
  IntervalType,
  DatePickerMode,
} from 'chronos-types';

import * as actions from 'chronos-actions';
import * as selectors from 'chronos-selectors';

import {
  DatePicker,
} from 'chronos-components';

type Props = {
  date: IntervalType,
  datePickerMode: DatePickerMode,
  dispatch: Function,
};

const mapState: Props = state => ({
  date: selectors.getUiState('calendarDate')(state),
  datePickerMode: selectors.getUiState('datePickerMode')(state),
});

const DatePickerContainer = () => {
  const {
    date,
    datePickerMode,
  } = useSelector(mapState);
  const dispatch: Dispatch = useDispatch();

  return (
    <DatePicker
      date={date}
      mode={datePickerMode}
      onChangeMode={(mode) => {
        dispatch({
          type: actionTypes.READ_RESOURCES_PENDING,
          list: 'issues',
          resourceType: 'issues',
          requestKey: 'loadingFilterOptions',
        });
        if (mode === 'Day') {
          dispatch(actions.setUiState({
            calendarDate: (
              Interval.fromDateTimes(
                DateTime.local(),
                DateTime.local(),
              )
            ),
          }));
        }
        if (mode === 'Month') {
          dispatch(actions.setUiState({
            calendarDate: (
              Interval.fromDateTimes(
                DateTime.local().startOf('month'),
                DateTime.local().endOf('month'),
              )
            ),
          }));
        }
        if (mode === 'Week') {
          dispatch(actions.setUiState({
            calendarDate: (
              Interval.fromDateTimes(
                DateTime.local().startOf('week').minus({ days: 1 }),
                DateTime.local().endOf('week').minus({ days: 1 }),
              )
            ),
          }));
        }
        dispatch(actions.setUiState({
          datePickerMode: mode,
        }));
        dispatch(actions.refreshRequest({
          debouncing: false,
        }));
      }}
      onClose={() => {
        dispatch(actions.setUiState({ calendarDate: date }));
      }}
      onChange={(value) => {
        dispatch({
          type: actionTypes.READ_RESOURCES_PENDING,
          list: 'issues',
          resourceType: 'issues',
          requestKey: 'loadingFilterOptions',
        });
        dispatch(actions.setUiState({ calendarDate: value }));
        dispatch(actions.refreshRequest());
      }}
    />
  );
};

export default DatePickerContainer;
